import { ApiError } from '../shared/api.js';
import { errorMessage } from '../garage/lib/errors.js';

/** Délai d'attente lisible : « une minute », « 30 minutes » (arrondi à la minute supérieure). */
export function formatWait(seconds: number): string {
  const minutes = Math.max(1, Math.ceil(seconds / 60));
  return minutes === 1 ? 'une minute' : `${minutes} minutes`;
}

/** `retryAfterSeconds` des détails d'une réponse 429 (blocage du compte), s'il est présent. */
export function retryAfterSeconds(err: unknown): number | null {
  if (!(err instanceof ApiError) || err.status !== 429) return null;
  const d = err.details as { retryAfterSeconds?: unknown } | undefined;
  return typeof d?.retryAfterSeconds === 'number' && d.retryAfterSeconds > 0 ? d.retryAfterSeconds : null;
}

/** Trop de tentatives : avec le délai donné par le serveur, sinon la fenêtre d'une minute (limite par IP). */
export function tooManyAttemptsMessage(err: unknown): string {
  const s = retryAfterSeconds(err);
  return s === null
    ? 'Trop de tentatives. Patientez une minute avant de réessayer.'
    : `Trop de tentatives. Par sécurité, la connexion est suspendue : réessayez dans ${formatWait(s)}.`;
}

/**
 * Erreur de connexion. Identifiants : un seul message, que l'e-mail existe ou non (aucune énumération) ;
 * trop de tentatives : délai explicite ; sinon le message commun (réseau, serveur).
 */
export function loginErrorMessage(err: unknown): string | null {
  if (!err) return null;
  if (err instanceof ApiError) {
    if (err.status === 401 || err.status === 400) return 'E-mail ou mot de passe incorrect.';
    if (err.status === 429) return tooManyAttemptsMessage(err);
  }
  return errorMessage(err);
}

/** Erreur d'une demande publique (mot de passe oublié, invitation) : 429 explicite, sinon message commun. */
export function publicErrorMessage(err: unknown): string | null {
  if (!err) return null;
  if (err instanceof ApiError && err.status === 429) return tooManyAttemptsMessage(err);
  return errorMessage(err);
}
